/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnerscolumnsignedup3Inputs */

const en_partnerscolumnsignedup3 = /** @type {(inputs: Partnerscolumnsignedup3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signed up`)
};

const de_partnerscolumnsignedup3 = /** @type {(inputs: Partnerscolumnsignedup3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angemeldet`)
};

/**
* | output |
* | --- |
* | "Signed up" |
*
* @param {Partnerscolumnsignedup3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnerscolumnsignedup3 = /** @type {((inputs?: Partnerscolumnsignedup3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnerscolumnsignedup3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnerscolumnsignedup3(inputs)
	return de_partnerscolumnsignedup3(inputs)
});
export { partnerscolumnsignedup3 as "partnersColumnSignedUp" }